import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../assets/font/Sk-Modernist-Mono.otf%22,%22weight%22:%22100%22},{%22path%22:%22../assets/font/Sk-Modernist-Regular.otf%22,%22weight%22:%22400%22},{%22path%22:%22../assets/font/Sk-Modernist-Bold.otf%22,%22weight%22:%22600%22}],%22variable%22:%22--font-modernist%22}],%22variableName%22:%22modernist%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'modernist', 'modernist Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
